var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHouse({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-house",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 15 14",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6,13.2V9c0-0.1,0.1-0.2,0.2-0.2h2.6C8.9,8.8,9,8.9,9,9v4.2c0,0.1,0.1,0.2,0.2,0.2 h3.4c0.1,0,0.2-0.1,0.2-0.2V7.5c0-0.1,0.1-0.2,0.2-0.2h1.3c0,0,0.3,0,0.4-0.1c0.1-0.2-0.2-0.4-0.2-0.4L8,0.8 C7.7,0.6,7.3,0.6,7,0.8L0.6,6.7c0,0-0.2,0.2-0.2,0.3c0,0.2,0.4,0.2,0.4,0.2h1.3c0.1,0,0.2,0.1,0.2,0.2v5.7c0,0.1,0.1,0.2,0.2,0.2 h3.4C5.9,13.4,6,13.3,6,13.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.c6b002dfe219e3c4b546831d7e36f7a9.svg";
export { ForwardRef as ReactComponent };